import React from 'react';
import '../template-file-css/document-file-template.css';


export const GENERAL_SignificantProviderChanges = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='GENERAL_SignificantProviderChanges' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'> <center> <h3> <b> NOTIFICATION OF SIGNIFICANT PROVIDER CHANGES </b> </h3> </center>
                </p>

                <p className='w-750'> <span className='eleHeader'> CASE MANAGEMENT PROVIDER: </span>
                </p>

                <p className='w-750'> <input type='text' id='txtCaseManagement' name='txtCaseManagement' className='add-only' />
                </p>

                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> PROVIDER NPI: </span> </td>
                        <td className='w-375'> <span className='eleHeader'> REGION: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtProviderNpi' name='txtProviderNpi' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtRegion' name='txtRegion' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <input type='checkbox' id='cbChangeInCase' name='cbChangeInCase' className='add-only' value='CLIENT/FAMILY RELOCATED' /> <b> CHANGE IN CASE MANAGERS (RESUME, CONFLICT OF INTEREST STATEMENT, AND LICENSURE MUST BE SUBMITTED TO ADD NEW CASE MANAGERS.) </b>
                </p>

                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> NAME: </span> </td>
                        <td className='w-375'> <span className='eleHeader'> EFFECTIVE DATE: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtName_1' name='txtName_1' className='add-only' /> </td>
                        <td className='w-375'> <input type='date' id='txtEffectiveDate_1' name='txtEffectiveDate_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' id='cbAddition_1' name='cbAddition_1' className='add-only' value='ADDITION' /> ADDITION </td>
                        <td className='w-200'>
                            <input type='checkbox' id='cbDeletion_1' name='cbDeletion_1' className='add-only' value='DELETION' /> DELETION </td>
                        <td className='w-200'>
                            <input type='checkbox' id='cbEmployed_1' name='cbEmployed_1' className='add-only' value='EMPLOYED' /> EMPLOYED </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbContracted_1' name='cbContracted_1' className='add-only' value='CONTRACTED' /> CONTRACTED
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'> <span className='eleHeader'> NAME: </span> </td>
                        <td className='w-375'> <span className='eleHeader'> EFFECTIVE DATE: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtName_2' name='txtName_2' className='add-only' /> </td>
                        <td className='w-375'> <input type='date' id='txtEffectiveDate_2' name='txtEffectiveDate_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' id='cbAddition_2' name='cbAddition_2' className='add-only' value='ADDITION' /> ADDITION </td>
                        <td className='w-200'>
                            <input type='checkbox' id='cbDeletion_2' name='cbDeletion_2' className='add-only' value='DELETION' /> DELETION </td>
                        <td className='w-200'>
                            <input type='checkbox' id='cbEmployed_2' name='cbEmployed_2' className='add-only' value='EMPLOYED' /> EMPLOYED </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbContracted_2' name='cbContracted_2' className='add-only' value='CONTRACTED' /> CONTRACTED
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <input type='checkbox' id='cbContactPerson' name='cbContactPerson' className='add-only' value='CHANGE IN CONTACT' /> <b> CHANGE IN CONTACT PERSON </b>
                </p>

                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> ADMINISTRATIVE CONTACT: </span> </td>
                        <td className='w-375'> <span className='eleHeader'> TELEPHONE NUMBER: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtAdministrative' name='txtAdministrative' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtTelephoneNumber_1' name='txtTelephoneNumber_1' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-375'> <span className='eleHeader'> CASE MANAGEMENT DIRECTOR: </span> </td>
                        <td className='w-375'> <span className='eleHeader'> TELEPHONE NUMBER: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtManagementDirector' name='txtManagementDirector' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtTelephoneNumber_2' name='txtTelephoneNumber_2' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <input type='checkbox' id='cbProviderStatus' name='cbProviderStatus' className='add-only' value='CHANGE IN CONTACT' /> <b> CHANGE IN PROVIDER STATUS </b>
                </p>

                <p className='w-750'> <span className='eleHeader'> EFFECTIVE DATE: </span>
                </p>

                <p className='w-750'> <input type='date' id='txtEffectiveDate_3' name='txtEffectiveDate_3' className='add-only' />
                </p>

                <p className='w-750'>
                    <input type='checkbox' id='cbNoticeOfClosing' name='cbNoticeOfClosing' className='add-only' value='NOTICE OF CLOSING' /> NOTICE OF CLOSING <b> (MUST CHECK ONE OF THE BOXES BELOW) </b>
                </p>

                <p className='w-750'>
                    <input type='checkbox' id='cbDisenrolled' name='cbDisenrolled' className='add-only' value='CHANGE IN CONTACT' /> I HAVE DISENROLLED AS A CPW PROVIDER WITH TMHP. I AM NOT ACCEPTING NEW REFERRALS AND CURRENTLY NOT SERVING ANY CLIENTS.
                </p>

                <p className='w-750'>
                    <input type='checkbox' id='cbCurrentClients' name='cbCurrentClients' className='add-only' value='CHANGE IN CONTACT' /> I WILL DISENROLL WITH TMHP AS A CPW PROVIDER AFTER I HAVE COMPLETED SERVICES TO CURRENT CLIENTS.
                </p>

                <p className='w-750'>
                    <input type='checkbox' id='cbRemainingEnrolled' name='cbRemainingEnrolled' className='add-only' value='CHANGE IN CONTACT' /> I AM REMAINING ENROLLED AS A CPW PROVIDER, BUT DO NOT CURRENTLY HAVE AN ELIGIBLE CASE MANAGER IN GROUP AT THIS TIME. I PLAN TO HIRE A CASE MANAGER TO FILL THIS POSITION.
                </p>

                <p className='w-750'>
                    <input type='checkbox' id='cbOther_1' name='cbOther_1' className='add-only' value='CHANGE IN CONTACT' /> OTHER
                </p>
                <p className='w-750'> <input type='text' id='txtOther' name='txtOther' className='add-only' />
                </p>

                <p className='w-750'>
                    <input type='checkbox' id='cbProviderInformation' name='cbProviderInformation' className='add-only' value='CHANGE IN CONTACT' /> <b> CHANGE IN PROVIDER INFORMATION </b>
                </p>

                <p className='w-750'> ALL CHANGES MUST ALSO BE MADE WITH TMHP BEFORE THEY WILL BE REFLECTED ON THE HHSC WEBSITE PROVIDER LISTING. (SUBMIT PROVIDER
                    INFORMATION CHANGE AT TMHP.COM)
                </p>

                <p className='w-750'> <span className='eleHeader'> GROUP OR CASE MANAGER NAME: </span>
                </p>

                <p className='w-750'> <input type='text' id='txtCaseManager' name='txtCaseManager' className='add-only' />
                </p>
                <p className='small w-750'> (PROVIDERS WITH IN A GROUP AND INDIVIDUAL PROVIDERS MUST CHANGE THEIR RN/SW LICENSURE TO REFLECT NEW NAME BEFORE NOTIFYING TMHP. THIS DOES NOT APPLY TO A CM WITHIN A FQHC.)
                </p>

                <table>
                    <tr>
                        <td className='w-500'> <span className='eleHeader'> ADDRESS: </span> </td>
                        <td className='w-250'> <span className='eleHeader'> TELEPHONE NUMBER: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtAddress' name='txtAddress' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtTelephoneNumber_3' name='txtTelephoneNumber_3' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-500'> <span className='eleHeader'> FAX NUMBER: </span> </td>
                        <td className='w-250'> <span className='eleHeader'> EMAIL: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtFaxNumber' name='txtFaxNumber' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtEmail' name='txtEmail' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'> <b> NOTE: PROVIDERS MUST INFORM CURRENT CLIENTS OF ANY PHONE NUMBER CHANGES </b>
                </p>

                <p className='w-750'> <span className='eleHeader'> CHANGE IN EMPLOYMENT: </span>
                </p>

                <p className='w-750'> <input type='text' id='txtChangeInEmployment' name='txtChangeInEmployment' className='add-only' />
                </p>
                <p className='small w-750'> (IF A CASE MANAGER HAS OBTAINED DUAL EMPLOYMENT OR CHANGED THEIR EMPLOYER, THEY MUST SUBMIT AN UPDATED CONFLICT OF INTEREST STATEMENT TO HHSC-CM)
                </p>

                <p className='w-750'> <span className='eleHeader'> LIST OTHER CHANGES, SUCH AS CHANGE IN POPULATION SERVED, COUNTIES, ZIP CODES SERVED: </span>
                </p>

                <p className='w-750'> <input type='text' id='txtListOtherChanges' name='txtListOtherChanges' className='add-only' />
                </p>

                <p className='w-750'> PROVIDER SHOULD ALSO INFORM CONTRACTED MCOs OF CHANGES.
                </p>

                <table>
                    <tr>
                        <td className='signature w-375'> &nbsp; </td>
                        <td className='signature w-375'> &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> SIGNATURE OF PERSON COMPLETING FORM </td>
                        <td className='small w-375'> DATE </td>
                    </tr>

                    <tr>
                        <td className='signature w-750'> &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-750'> PRINTED NAME OF PERSON COMPLETING FORM </td>
                    </tr>
                </table>






            </div>
        </form>

    )
}











